import { axios } from "lib/axios";

export const checkAccountStatus = (data) => {
  return axios.post("/users/check-account-status", data);
};
